/*
 * Copyright (c) 2020 Little Robot Friends, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {Block} from 'baseui/block'
import {Button} from 'baseui/button'
import {Card, StyledBody} from 'baseui/card'
import {FlexGrid, FlexGridItem} from 'baseui/flex-grid'
import {FormControl} from 'baseui/form-control'
import {Input} from 'baseui/input'
import React from 'react'
import {defaultProfileData} from '../../utils/config'
import UserAvatar from './user-avatar'
import UserField from './user-field'

const ProfileUserCard = props => {
  const {changed, handleInputChange, handleSubmit, loading, profile, currentProfile} = props

  const gridItemProps = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'start',
    justifyContent: 'start',
  }

  return (
    <Block
      overrides={{
        Block: {
          style: ({$theme}) => ({
            flexBasis: '63%',
            width: '100%',
          }),
        },
      }}
    >
      <Card
        title={profile.displayName || defaultProfileData.displayName.value}
        overrides={{
          Block: {
            style: ({$theme}) => ({
              marginBottom: $theme.sizing.scale800,
            }),
          },
        }}
      >
        <StyledBody>
          <FlexGrid
            flexGridColumnCount={[1, 1, 2]}
            flexGridColumnGap="scale800"
            flexGridRowGap="scale800"
          >
            <FlexGridItem {...gridItemProps}>
              <Block
                overrides={{
                  Block: {
                    style: ({$theme}) => ({
                      ...$theme.borders.border100,
                      borderRadius: $theme.borders.radius300,
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'space-between',
                      height: '100%',
                      paddingBottom: $theme.sizing.scale200,
                      width: '100%',
                    }),
                  },
                }}
              >
                <UserAvatar />
                <Block>
                  <UserField field={profile.firstName} label={defaultProfileData.firstName.key} />
                  <UserField field={profile.lastName} label={defaultProfileData.lastName.key} />
                  <UserField field={profile.email} label={defaultProfileData.email.key} />
                </Block>
              </Block>
            </FlexGridItem>
            <FlexGridItem {...gridItemProps}>
              <Block
                $as="form"
                noValidate
                onSubmit={handleSubmit}
                overrides={{
                  Block: {
                    style: {
                      display: 'flex',
                      flexDirection: 'column',
                      width: '100%',
                    },
                  },
                }}
              >
                <FormControl label={defaultProfileData.firstName.key} error="">
                  <Input
                    name="firstName"
                    error=""
                    value={currentProfile.firstName}
                    onChange={handleInputChange}
                    autoComplete="off"
                  />
                </FormControl>
                <FormControl label={defaultProfileData.lastName.key} error="">
                  <Input
                    name="lastName"
                    error=""
                    value={currentProfile.lastName}
                    onChange={handleInputChange}
                    autoComplete="off"
                  />
                </FormControl>
                <FormControl label={defaultProfileData.displayName.key} error="">
                  <Input
                    name="displayName"
                    error=""
                    value={currentProfile.displayName}
                    onChange={handleInputChange}
                    autoComplete="off"
                  />
                </FormControl>
                <Button
                  endEnhancer={() => <FontAwesomeIcon icon="cloud" />}
                  isLoading={loading}
                  disabled={loading || !changed}
                  overrides={{
                    BaseButton: {
                      style: ({$theme}) => ({
                        marginTop: $theme.sizing.scale400,
                      }),
                    },
                  }}
                >
                  Update
                </Button>
              </Block>
            </FlexGridItem>
          </FlexGrid>
        </StyledBody>
      </Card>
    </Block>
  )
}

export default ProfileUserCard
